import React from 'react';
import RegularHoursCandleNote from './RegularHoursCandleNote';

const FtfcFilterDocs = (
    <html>
    <p>
        This is a filter that tracks full time frame continuity. This setup only allow
        trades in which all time frames you provide us are above
        the open if long, or below the open if short.
    </p>
    <p>
        You choose these setups by manipulating the list that shows when you click
        the FTFC setup. "m" is for minute, "d" is for day, "w is for week, "M" is
        for month. The parameter candle represents the candle duration of the time
        frame. For an equity-style regular-session 60 minute candle, you would type in 60
        for the candle parameter, and click "m" as the timeUnit.
    </p>
    <p>
        The red X button on the right will remove the associated timeFrame. The
        green plus beneath with add another timeFrame.
    </p>
    EX:
    <p>
        Let's say I want to trade AAPL, either long or short, but I only want to if the 1 hour, the 1
        day, the 1 week, and the 1 month, all are the same color. I would enter the filter as:
        60m, 1d, 1w, and 1m. If, when the entry tactic triggers, all of those time frames
        are above their respective open (the UI will show green), and the Trade Plan is long,
        the trade will pass the filter. If even one is red, the filter will fail. The opposite is true for shorts.
        If the Trade Plan is short, and all of those time frames are below their
        respective open, it will allow a trigger short. If even one time frame is green, the filter will fail.
    </p>
    {RegularHoursCandleNote}
    </html>
);
export default FtfcFilterDocs;
